<template>
  <div>
    <div class="list-stickies">
      <h2 v-if="title">{{ title }} </h2>

      <list-filter v-if="filterableTags.length > 0 || searchable" :list="items" :on-filter='setVisibleItems' :tags="filterableTags" :filter-levels="filterLevels"></list-filter>

      <div v-for='item in visibleItems' class='entry' :ref='`item-${item.id}`'>
        <slot :item="item"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import listable from '../shared/listable.vue';
  import ListFilter from '../shared/list-filter.vue';
  import { includes, kebabCase } from 'lodash';

  export default {
    props: {
      title: {
        type: String,
        default: null
      },

      items: {
        type:    Array,
        default: []
      },

      filterableTags: {
        type: Array,
        default: () => []
      },

      searchable: {
        type: Boolean,
        default: false
      },

      filterLevels: {
        type: Boolean,
        default: false
      }
    },

    data: function(){
      return {
        filteredItems: null,
        selectedItemKebabName: null
      }
    },

    components: { listable, ListFilter },

    mounted() {
      const url = new URL(window.location);
      const params = new URLSearchParams(url.search);

      this.selectedItemKebabName = params.get('item');
    },

    computed: {
      visibleItems() {
        return this.filteredItems || this.items;
      },

      highlightedItem() {
        return this.visibleItems.find(item => kebabCase(item.get('name')) == this.selectedItemKebabName) || this.visibleItems[0];
      }
    },

    methods: {
      setHighlightedItem: function(item){
        const url = new URL(window.location);
        const params = new URLSearchParams(url.search);
        params.set('item', kebabCase(item.get('name')));

        window.history.replaceState({}, '', `${url.origin}${url.pathname}?${params.toString()}`)

        console.log('ref item: ', this.$refs[`item-${item.id}`]);

        this.$refs[`item-${item.id}`][0].scrollIntoView({ behavior: 'smooth' });
      },

      setVisibleItems: function(items) {
        this.filteredItems = items;

        if (!includes(items, this.selectedItem)) {
          this.selectedItem = null;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .highlighted-item {
    display: inline-block;
    vertical-align: top;
    height: 100%;
    position: absolute;
    right: 0;
    width: 75%;
    padding: 15px;
  }  
</style>
